import React from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

const SkillItem = styled.div`
  display: flex;
  flex-flow: column;
  margin: 0 0 20px;

  &:last-child {
    margin: 0;
  }

  .SkillItem__header {
    display: flex;
    font-size: 20px;
    flex-flow: row nowrap;
    align-items: center;

    @media screen and (max-width: 600px) {
      font-size: 18px;
      align-items: flex-start;
      flex-flow: column;
    }
  }

  .SkillItem__title {
    font-weight: 700;
    line-height: 1;

    a {
      color: inherit;
      &:after {
        color: ${theme.A500};
        font-size: 70%;
        font-style: italic;
        margin-left: 5px;
        content: 'link';
      }
    }
  }

  .SkillItem__subtitle {
    font-weight: 300;
    font-style: italic;
  }

  .SkillItem__details {
    margin-left: auto;
    font-weight: 700;

    @media screen and (max-width: 600px) {
      margin-left: inherit;
      font-weight: 500;
      font-style: italic;
    }
  }

  .SkillItem__content {
    font-size: 18px;
    line-height: 1.2;

    p {
      margin: 0 0 15px;

      &.small {
        font-size: 80%;
      }

      &:last-child {
        margin: 0;
      }
    }
  }
`;

export default props => (
  <SkillItem>
    {(props.header || props.details) && (
      <div className="SkillItem__header">
        {props.header && (
          <div className="SkillItem__title">
            {props.header}
            {props.subtitle && (
              <div className="SkillItem__subtitle">
                {'&nbsp;//&nbsp;'}
                {props.subtitle}
              </div>
            )}
          </div>
        )}
        {props.details && <div className="SkillItem__details">{props.details}</div>}
      </div>
    )}
    <div className="SkillItem__content">{props.children}</div>
  </SkillItem>
);



// WEBPACK FOOTER //
// ./src/components/Skill/SkillItem.js